import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { SitioProcesamiento } from './sitios-procesamiento.model';
import { environment } from 'projects/registro-personas-empresas/src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SitiosProcesamientoService {
  endpoint = 'plantasProcesamiento';

  constructor(private http: HttpClient) {}

  getSitiosProcesamiento(): Observable<SitioProcesamiento[]> {
    return this.http.get<SitioProcesamiento[]>(
      `${environment.apiUrl}/${this.endpoint}/`
    );
  }

  addSitiosProcesamiento(
    sitiosProcesamiento: SitioProcesamiento[]
  ): Observable<SitioProcesamiento[]> {
    return this.http.post<SitioProcesamiento[]>(
      `${environment.apiUrl}/${this.endpoint}/`,
      {
        plantasProcesamiento: sitiosProcesamiento
      }
    );
  }

  deleteSitiosProcesamiento(
    sitioProcesamiento: SitioProcesamiento
  ): Observable<SitioProcesamiento> {
    return this.http.delete<SitioProcesamiento>(
      `${environment.apiUrl}/${this.endpoint}/${sitioProcesamiento.id}/`
    );
  }
}
